import React from "react";

// Minimal, premium inline brand glyphs (single-color, currentColor).
const paths = {
  instagram: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="5.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" />
    </>
  ),
  facebook: (
    <path
      fill="currentColor"
      d="M13.5 21v-7h2.4l.4-2.8h-2.8V9.4c0-.8.3-1.4 1.5-1.4h1.4V5.5c-.7-.1-1.5-.2-2.3-.2-2.3 0-3.9 1.4-3.9 4v2H8v2.8h2.7V21h2.8z"
    />
  ),
  tiktok: (
    <path
      fill="currentColor"
      d="M16.5 3c.3 1.9 1.4 3.4 3.5 3.6v2.5c-1.2.1-2.3-.3-3.5-1v5.7c0 3.2-2.4 5.2-5.2 5.2-2.7 0-4.8-1.9-4.8-4.6 0-2.8 2.3-4.7 5-4.5v2.6c-.4-.1-.8-.2-1.2-.1-1.1.2-1.9 1-1.8 2.2.1 1.1 1 1.9 2.1 1.8 1.2-.1 1.9-1 1.9-2.3V3h2.5z"
    />
  ),
  pinterest: (
    <path
      fill="currentColor"
      d="M12 2.5C6.9 2.5 4 5.9 4 9.3c0 1.6.9 3.5 2.3 4.1.2.1.4 0 .4-.2 0-.1.1-.5.2-.7 0-.2 0-.3-.1-.5-.4-.5-.7-1.3-.7-2.1 0-2.7 2-5.3 5.3-5.3 2.9 0 4.8 1.8 4.8 4.2 0 3.2-1.4 5.4-3.2 5.4-1 0-1.8-.8-1.5-1.9.3-1.2.9-2.5.9-3.4 0-.8-.4-1.5-1.3-1.5-1 0-1.9 1.1-1.9 2.5 0 .9.3 1.6.3 1.6l-1.3 5.4c-.4 1.6-.1 3.5 0 3.7 0 .1.2.1.2 0 .1-.1 1.5-1.8 1.9-3.5l.7-2.8c.4.7 1.4 1.3 2.5 1.3 3.3 0 5.6-3 5.6-7C20 5.4 16.9 2.5 12 2.5z"
    />
  ),
  whatsapp: (
    <path
      fill="currentColor"
      d="M12 2.8a9.1 9.1 0 0 0-7.8 13.8L3 21.4l4.9-1.3A9.1 9.1 0 1 0 12 2.8zm0 1.8a7.3 7.3 0 0 1 6.2 11.2c-.2.3-.2.5-.1.8l.6 2.1-2.2-.6c-.3-.1-.5 0-.8.1A7.3 7.3 0 1 1 12 4.6zm-2.7 3.6c-.1 0-.4 0-.6.3-.2.3-.8.8-.8 1.9s.8 2.2.9 2.4c.1.2 1.6 2.6 4 3.5 2 .8 2.4.6 2.8.6.4 0 1.3-.5 1.5-1.1.2-.5.2-1 .1-1.1-.1-.1-.3-.2-.6-.3l-1.2-.6c-.2-.1-.4-.1-.5.1l-.5.7c-.1.1-.3.2-.5.1-.3-.1-1.1-.4-2-1.2-.7-.6-1.2-1.4-1.3-1.6-.1-.2 0-.4.1-.5l.4-.4c.1-.2.2-.3.2-.5s0-.4-.1-.5l-.6-1.4c-.1-.4-.3-.4-.5-.4z"
    />
  ),
};

export const SocialIcon = ({ name, ...props }) => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
    {paths[name]}
  </svg>
);

export const SOCIAL_LABELS = {
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  pinterest: "Pinterest",
  whatsapp: "WhatsApp",
};
